import * as Sentry from '@sentry/gatsby';

import { defaultSentryConfig } from './sentry.util';

Sentry.init({
  ...defaultSentryConfig,
  ignoreErrors: ['TypeError'],
  sampleRate: 0.1,
});
